import { Entity } from '@backstage/catalog-model';
import { EntityFilter } from '@backstage/plugin-catalog-react';

/**
 * Filter entities based on Schibsted criticality level.
 * @public
 */
export class EntityCriticalityFilter implements EntityFilter {
  constructor(readonly values: string[]) {}

  getCatalogFilters(): Record<string, string | string[]> {
    return { 'metadata.schibsted-criticality': this.values };
  }

  filterEntity(entity: Entity): boolean {
    const criticality = (entity.metadata as any)['schibsted-criticality'];
    return this.values.includes(criticality);
  }

  toQueryValue(): string[] {
    return this.values;
  }
}
